import styled from "@emotion/styled"
import { useConsole } from "contexts/Console"
import { surtitle70 } from "css/text"

const Figure = styled.figure`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 0.5ex;

  figcaption {
    ${surtitle70}
  }
`

export default function Rftc({ text }) {
  const console = useConsole()

  return (
    <Figure>
      <svg viewBox='0 0 207.1 224.8' xmlns='http://www.w3.org/2000/svg' fill='currentColor' width='1.25rem' height='1.25rem' aria-hidden='true'>
        <path d='m62.8 164.5-43.5-93.1c4.2-2.2 7.1-6.6 7.1-11.7 0-7.3-5.9-13.2-13.2-13.2s-13.2 5.9-13.2 13.2 5.9 13.2 13.2 13.2 2.2-.2 3.3-.4l37.5 127.3c4.2 14.2 24.9 25 49.8 25s45.6-10.8 49.8-25l37.4-127.2c.9.2 1.9.3 2.9.3 7.3 0 13.2-5.9 13.2-13.2s-5.9-13.2-13.2-13.2-13.2 5.9-13.2 13.2 3.1 9.7 7.5 11.9l-43.4 93 7-125.3h.3c7.3 0 13.2-5.9 13.2-13.2s-5.9-13.2-13.2-13.2-13.2 5.9-13.2 13.2 4 11 9.5 12.6l-28.9 122.5-13.9-135c6.4-.9 11.3-6.4 11.3-13s-5.9-13.2-13.2-13.2-13.2 5.9-13.2 13.2 5 12.2 11.4 13l-13.9 134.8-28.8-122.2c5.5-1.6 9.6-6.6 9.6-12.7s-5.9-13.2-13.2-13.2-13.2 5.9-13.2 13.2 5.9 13.2 13.2 13.2h.2zm40.8 24.5c22.8 0 41.3 5.8 41.3 13s-18.5 13-41.3 13-41.3-5.8-41.3-13 18.5-13 41.3-13' />
      </svg>
      <figcaption>{text}</figcaption>
    </Figure>
  )
}
